import { render, staticRenderFns } from "./Use-Block.vue?vue&type=template&id=66eac10a&scoped=true"
import script from "./Use-Block.vue?vue&type=script&lang=js"
export * from "./Use-Block.vue?vue&type=script&lang=js"
import style0 from "./Use-Block.vue?vue&type=style&index=0&id=66eac10a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eac10a",
  null
  
)

export default component.exports